var display_charts = function (data) {
  console.log("display_charts called with data:", data);

  if (!window.Chart) {
    console.error("Chart.js is not loaded!");
    return;
  }

  if (!$("#chart_container").length) {
    console.error("Chart container element not found!");
    return;
  }

  var count = 0;
  data["tables"].forEach(function (table) {
    var chart_id = "chart" + count;

    // Create canvas element for Chart.js
    var canvasElement = $("<canvas>").attr({
      id: chart_id,
      width: 375,
      height: 325,
    });

    var containerDiv = $("<div>").css({
      backgroundColor: "#fff",
    });

    containerDiv.append(canvasElement);
    $("#chart_container").append(containerDiv);

    // Convert data to Chart.js format
    var chartData = {
      datasets: table.traces.map(function (trace, index) {
        // Create x-y pairs for proper scatter plot
        var data = [];
        for (var i = 0; i < trace.x.length; i++) {
          data.push({ x: trace.x[i], y: trace.y[i] });
        }
        
        // Color palette for multiple lines
        var colorPalette = [
          "#1f77b4", // Blue (default)
          "#ff7f0e", // Orange
          "#2ca02c", // Green
          "#d62728", // Red
          "#9467bd", // Purple
          "#8c564b", // Brown
          "#e377c2", // Pink
          "#7f7f7f", // Gray
          "#bcbd22", // Olive
          "#17becf"  // Cyan
        ];
        
        // Use different colors for charts with multiple traces
        var lineColor = colorPalette[index % colorPalette.length];
        
        return {
          label: trace.name || "",
          data: data,
          fill: false,
          borderColor: lineColor,
          backgroundColor: lineColor,
          tension: trace.line && trace.line.shape === "spline" ? 0.4 : 0,
          pointRadius: 0,
          borderWidth: 2,
        };
      }),
    };

    // Convert layout to Chart.js options
    var chartOptions = {
      responsive: false,
      maintainAspectRatio: false,
      backgroundColor: "#fff",
      plugins: {
        title: {
          display: table.layout.title ? true : false,
          text: table.layout.title || "",
          font: {
            size: 17,
            family: "'San Francisco', 'Segoe UI', Verdana, sans-serif",
            weight: "normal",
          },
          color: "#444",
          padding: {
            top: 0,
            bottom: 20,
          },
        },
        legend: {
          display: false,
        },
        tooltip: {
          mode: "nearest",
          intersect: false,
          callbacks: {
            title: function (context) {
              return "";
            },
            label: function (context) {
              var xValue = context.parsed.x;
              var yValue = context.parsed.y;
              return "X: " + xValue.toFixed(2) + ", Y: " + yValue.toFixed(2);
            },
          },
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          titleColor: "#fff",
          bodyColor: "#fff",
          borderColor: "#333",
          borderWidth: 1,
        },
      },
      scales: {
        x: {
          type: "linear",
          beginAtZero: false,
          display: true,
          title: {
            display: table.layout.xaxis && table.layout.xaxis.title ? true : false,
            text: table.layout.xaxis ? table.layout.xaxis.title : "",
            font: {
              size: table.layout.xaxis && table.layout.xaxis.titlefont ? table.layout.xaxis.titlefont.size : 13,
              family: "'San Francisco', 'Segoe UI', Verdana, sans-serif",
            },
            color: "#444",
            padding: { top: 10 },
          },
          min: table.layout.xaxis && table.layout.xaxis.range ? table.layout.xaxis.range[0] : undefined,
          max: table.layout.xaxis && table.layout.xaxis.range ? table.layout.xaxis.range[1] : undefined,
          grid: {
            display: table.layout.xaxis ? table.layout.xaxis.showgrid : true,
            color: "#eee",
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 4,
            tickColor: "#fff",
            lineWidth: 1,
          },
          border: {
            display: true,
            color: "#eee",
            width: 1,
          },
          ticks: {
            color: "#444",
            padding: 5,
            font: {
              size: 12,
              family: "'San Francisco', 'Segoe UI', Verdana, sans-serif",
            },
            maxRotation: 0,
            minRotation: 0,
            autoSkip: false,
            // Format ticks - consistent decimal places within chart
            callback: function (value, index, ticks) {
              // Determine maximum decimal places needed in this chart
              var maxDecimals = 0;
              for (var i = 0; i < ticks.length; i++) {
                var tickValue = ticks[i].value;
                // Check if it needs 1 or 2 decimal places
                if (tickValue % 1 !== 0) {
                  // Check if 1 decimal is sufficient
                  if (Math.abs((tickValue * 10) % 1) < 0.0001) {
                    maxDecimals = Math.max(maxDecimals, 1);
                  } else {
                    maxDecimals = 2;
                  }
                }
              }
              
              // Apply consistent formatting
              return maxDecimals === 0 ? value.toString() : value.toFixed(maxDecimals);
            },
          },
          // Use afterBuildTicks to set exact tick positions when tickvals are provided
          afterBuildTicks:
            table.layout.xaxis && table.layout.xaxis.tickvals
              ? function (axis) {
                  // Determine maximum decimal places needed
                  var maxDecimals = 0;
                  table.layout.xaxis.tickvals.forEach(function(tickValue) {
                    if (tickValue % 1 !== 0) {
                      if (Math.abs((tickValue * 10) % 1) < 0.0001) {
                        maxDecimals = Math.max(maxDecimals, 1);
                      } else {
                        maxDecimals = 2;
                      }
                    }
                  });
                  
                  axis.ticks = table.layout.xaxis.tickvals.map(function (value) {
                    var label = maxDecimals === 0 ? value.toString() : value.toFixed(maxDecimals);
                    return { value: value, label: label };
                  });
                }
              : undefined,
        },
        y: {
          display: true,
          title: {
            display: table.layout.yaxis && table.layout.yaxis.title ? true : false,
            text: table.layout.yaxis ? table.layout.yaxis.title : "",
            font: {
              size: table.layout.yaxis && table.layout.yaxis.titlefont ? table.layout.yaxis.titlefont.size : 13,
              family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            },
            color: "#000",
            padding: { bottom: 10 },
          },
          grid: {
            display: true,
            color: "#eee",
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 4,
            tickColor: "#fff",
            lineWidth: 1,
          },
          border: {
            display: true,
            color: "#eee",
            width: 1,
          },
          position: "left",
          min: table.layout.yaxis && table.layout.yaxis.range ? table.layout.yaxis.range[0] : undefined,
          max: table.layout.yaxis && table.layout.yaxis.range ? table.layout.yaxis.range[1] : undefined,
          ticks: {
            color: "#000",
            padding: 5,
            font: {
              size: 11,
              family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            },
            // When we have dtick, force the exact configuration
            ...(table.layout.yaxis && table.layout.yaxis.dtick && table.layout.yaxis.range
              ? {
                  stepSize: table.layout.yaxis.dtick,
                  autoSkip: false,
                  count:
                    Math.floor((table.layout.yaxis.range[1] - table.layout.yaxis.range[0]) / table.layout.yaxis.dtick) +
                    1,
                  callback: function (value, index, ticks) {
                    // Determine maximum decimal places needed in this chart
                    var maxDecimals = 0;
                    for (var i = 0; i < ticks.length; i++) {
                      var tickValue = ticks[i].value;
                      if (tickValue % 1 !== 0) {
                        // Check if 1 decimal is sufficient
                        if (Math.abs((tickValue * 10) % 1) < 0.0001) {
                          maxDecimals = Math.max(maxDecimals, 1);
                        } else {
                          maxDecimals = 2;
                        }
                      }
                    }
                    
                    // Apply consistent formatting
                    return maxDecimals === 0 ? value.toString() : value.toFixed(maxDecimals);
                  },
                }
              : {
                  stepSize: table.layout.yaxis && table.layout.yaxis.dtick ? table.layout.yaxis.dtick : undefined,
                }),
          },
        },
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
          top: 20,
          bottom: 20,
        },
      },
    };

    // Create the chart
    var ctx = document.getElementById(chart_id).getContext("2d");
    new window.Chart(ctx, {
      type: "line",
      data: chartData,
      options: chartOptions,
    });

    count++;
  });
};

var get_charts = function () {
  console.log("get_charts called");
  var productPage = window.location.pathname.split("/")[1] == "product" ? true : false;
  var part_number = window.location.pathname.split("/").slice(-1)[0];
  console.log("Product page:", productPage, "Part number:", part_number);

  if (productPage && part_number.length < 20 && part_number.match(/^[/A-Za-z0-9-]+$/)) {
    console.log("Making AJAX request to:", "/chart_data/" + part_number);
    $.ajax({
      url: "/chart_data/" + part_number,
      success: function (data) {
        console.log("Chart data received:", data);
        if (data) {
          display_charts(data);
        }
      },
      error: function (xhr, status, error) {
        console.error("Chart loading failed:", status, error);
        console.error("Response:", xhr.responseText);
      },
    });
  } else {
    console.log("Conditions not met for chart loading");
  }
};

window.get_charts = get_charts;
